export const config = () => {
  let BASE_URL: string | any;
  BASE_URL = "https://www.casawalkin.com/api";
  // BASE_URL = "http://localhost:8081/api";
  return {
    BASE_URL
  };
};
